package streetlight.model.data

/** The services a location offers people in need. */
enum class ResourceType {
    FoodAssistance,
    Shelter,
    Medical,
    Bathroom,
    Water,
    Shower,
    Laundry,
    Storage,
    GoodVibes,
}